import { SelectFields } from '@repo/toolkit/types'

import { EnrollmentHealth } from '../../models/enrollment/enrollment-health'
import { FieldsSelector } from '../../utils'

export const enrollmentHealthBaseFields = [
  'id',
  'diphtheria',
  'tetanus',
  'poliomyelitis',
  'dtPolioTetracoq',
  'otherVaccinations',
  'pertussis',
  'hepatitisB',
  'rubellaMumpsMeasles',
  'bcg',
  'haemophilus',
  'pneumococcus',
  'meningococcusC',
  'additionalRecommendations'
] as const satisfies FieldsSelector<EnrollmentHealth>

export type EnrollmentHealthBaseType = SelectFields<
  EnrollmentHealth,
  typeof enrollmentHealthBaseFields
>

export const enrollmentHealthMedicalStatementFields = [
  'id',
  'diphtheria',
  'tetanus',
  'poliomyelitis',
  'dtPolioTetracoq',
  'otherVaccinations',
  'pertussis',
  'hepatitisB',
  'rubellaMumpsMeasles',
  'bcg',
  'haemophilus',
  'pneumococcus',
  'meningococcusC',
  'additionalRecommendations'
] as const satisfies FieldsSelector<EnrollmentHealth>

export type EnrollmentHealthMedicalStatement = SelectFields<
  EnrollmentHealth,
  typeof enrollmentHealthMedicalStatementFields
>
